import React from 'react';
import { AdminSidebar, AdminMobileHeader } from './AdminSidebar';

export function AdminLayout({ children }) {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Desktop Sidebar - hidden on mobile */}
      <AdminSidebar />
      
      {/* Mobile Header - hidden on desktop */}
      <AdminMobileHeader />
      
      {/* Main Content - no floating build marker */}
      <main className="lg:ml-64 flex-1 flex flex-col pt-16 lg:pt-0">
        <div className="flex-1">
          {children}
        </div>
      </main>
    </div>
  );
}

export default AdminLayout;
